import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Typography from 'material-ui/Typography'
import Card, { CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import {
  metersToFeet,
  picofaradsUnitConversion,
  getFormattedNumber
} from '../../../../../common/utils'
class TabularSubtest extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      direction: 'row',
      justify: 'center',
      alignItems: 'center'
    }
  }

  componentWillMount () {
    const { getSubtestResults, subtest, pager } = this.props
    getSubtestResults(pager.jid, pager.tid, subtest, 0)
  }

  componentWillReceiveProps (nextProps) {
    const {
      getSubtestResults,
      subtest,
      pager,
      subtestResultsDisplay,
      subtestResultsRemote
    } = nextProps

    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      if (!subtestResultsDisplay[subtest]) {
        getSubtestResults(pager.jid, pager.tid, subtest, 0)
      }
    }
  }

  lengthUnitConverter = length => {
    const { chartMeasurementUnit } = this.props
    if (chartMeasurementUnit === 'feet') {
      return metersToFeet(length)
    }
    return getFormattedNumber(length)
  }

  picofaradUnitConverter = (length, unitType) => {
    if (unitType === 'pF/ft') {
      return picofaradsUnitConversion(length, unitType)
    }
    return getFormattedNumber(length)
  }


  render () {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtestResultsRemote,
      subtest
    } = this.props
    const { alignItems, direction, justify } = this.state

    const subtesttype = results && results.data
      ? results.data.othersubtests.find(x => x.subtesttype === subtest)
      : null
    const measurementUnit = chartMeasurementUnit === 'feet' ? '(ft)' : '(m)'

    if (subtestResultsDisplay[subtest] && subtesttype) {
      const data = subtestResultsDisplay[subtest].data[0]
      const NVP = subtestResultsDisplay[subtest].NVP;
      let pairs = subtestResultsDisplay[subtest].pairs
      const limitIdx = pairs.findIndex(x => x === 'Limit')
      pairs = limitIdx !== -1 ? pairs.slice(0, -1) : pairs
      let limitVal = data[limitIdx]
        ? subtesttype.unit === 'm' || subtesttype.unit === 'pF'
            ? this.lengthUnitConverter(data[limitIdx])
            : data[limitIdx]
        : 0
      let unittype = subtesttype.unit
      if (subtesttype.unit === 'm' || subtesttype.unit === 'pF') {
        if (subtesttype.unit === 'm') {
          unittype = chartMeasurementUnit === 'feet' ? 'feet' : 'meters'
        }
        if (subtesttype.unit === 'pF') {
          unittype = chartMeasurementUnit === 'feet' ? 'pF/ft' : 'pF/m'
        }
      }
      let lengthUnitType = (unittype && unittype !== 'feet' && unittype !== 'ft') ? translate(unittype) : ''

      let _unittype = subtesttype.unit
      if (subtesttype.unit === 'm' || subtesttype.unit === 'pF') {
        if (subtesttype.unit === 'm') {
          _unittype = chartMeasurementUnit === 'feet' ? 'ft' : 'm'
        }
        if (subtesttype.unit === 'pF') {
          _unittype = chartMeasurementUnit === 'feet' ? 'pF/ft' : 'pF/m'
        }
      }
      let _lengthUnitType = (_unittype && _unittype !== 'feet' && _unittype !== 'ft') ? translate(_unittype) : ''

      let impedancePair = {}
      if (subtest === 'Impedance') {
        for (let index in pairs) {
          if (pairs[index] === 'Max') {
            impedancePair = { ...impedancePair, Max: index }
          }
          if (pairs[index] === 'Min') {
            impedancePair = { ...impedancePair, Min: index }
          }
        }
        pairs = pairs.filter((value, key) => {
          return !['Min', 'Max'].includes(value)
        })
      }

      const passed = subtestResultsDisplay[subtest].subteststatus !== 'Fail'
      return (
        <Grid container className={classes.root} justify='center'>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            <Card
              className={passed ? classes.borderpassed : classes.borderfailed}
            >
              <CardContent className={classes.cardContent}>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid
                      container
                      spacing={16}
                      className={ subtest == 'Length'? classes.demoNvp: classes.demo}
                      alignItems={alignItems}
                      direction={direction}
                      justify={justify}
                    >
                      <Grid item>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>{translate("general_pairs")}</TableCell>
                              <TableCell numeric> {translate("general_values")}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {pairs.map((pair, key) => {
                              return (
                                <TableRow key={key}>
                                  <TableCell component='th' scope='row'>
                                    {pair}
                                  </TableCell>
                                  <TableCell numeric>
                                    {subtesttype.unit === 'pF'
                                      ? this.picofaradUnitConverter(
                                        data[key],
                                        _unittype
                                      )
                                      : subtesttype.unit === 'm'
                                        ? this.lengthUnitConverter(data[key])
                                        : getFormattedNumber(data[key])}
                                    {' ' + _lengthUnitType}
                                  </TableCell>
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </Grid>
                      {subtest !== 'Impedance' &&
                        <Grid item>
                        <Typography className={ ['Length'].includes(subtest) ? (pairs.length == 1 ? classes.singlePair : (pairs.length == 2? classes.twoPair: classes.limitNVP)) : classes.button }>
                          {translate("general_limit")}
                            {' '}
                            {subtesttype.unit === 'pF'
                              ? data[limitIdx]
                                ? `<${this.picofaradUnitConverter(data[limitIdx], _unittype)}`
                                : <span className={classes.hyphen}>-</span>
                              : data[limitIdx]
                                ? (measurementUnit == '(ft)' && subtest === 'Length') ? limitVal :`<${getFormattedNumber(limitVal)}`
                                : <span className={classes.hyphen}>-</span>}
                            {' '}
                            {lengthUnitType}
                         
                        </Typography>
                        { subtest == 'Length' &&
                            <Typography className={ classes.nvp } gutterBottom>
                            { "NVP "+" " }
                            { NVP!=null ? NVP+"%" : "-" }
                            </Typography>
                        }
                        
                          {/* <Typography className={classes.title} gutterBottom>{data[limitIdx] ? `<${limitVal}` : limitVal}</Typography>
                          <Typography className={classes.button} gutterBottom></Typography> */}
                        </Grid>}
                        {(subtest === 'Impedance') && (
                        <Grid item>
                          <Typography className={classes.button}>
                          {translate("general_limit")}
                            {' '}
                            {Object.keys(impedancePair).map(key => {
                              return (
                                <Typography className={classes.impedancePair}>
                                  <Typography className={classes.impedancePairTitle}>
                                  {key == "Max" ?  translate('impedence_max') : translate('impedence_min') }
                                  </Typography>
                                  <Typography className={classes.impedancePairValue}>
                                    {getFormattedNumber(data[impedancePair[key]])}
                                  </Typography>
                                </Typography>
                              )
                            })
                            }
                            {' '}
                            {unittype && translate(unittype)}
                          </Typography>
                        </Grid>)
                      }
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={
                      passed ? classes.subtestpassed : classes.subtestfailed
                    }
                  >
                    <Typography
                      variant='headline'
                      component='h2'
                      className={classes.subtesttitle}
                    >
                      {/* passed */}
                      {translate(subtest)}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>

            </Card>
          </Grid>
        </Grid>
      )
    }
    return null
  }
}

export default withStyles(styles)(TabularSubtest)
